import { takeEvery, call, put, all, fork, spawn } from 'redux-saga/effects';

import { authActions } from './actions';
import { authService } from '../../services/auth';

import { onError } from '../../utils/onError';

function* whoAmIWatcher() {
  yield takeEvery(authActions.WHO_AM_I, function* () {
    try {
      const response = yield call(authService.whoAmI);
      yield put(authActions.whoAmISuccess(response.data));
    } catch (e) {
      yield put(authActions.whoAmIFail(e)); // TODO: action on fail
      yield spawn(onError, e);
    }
  });
}

export function* authSaga() {
  yield all([fork(whoAmIWatcher)]);
}
